// extracted by mini-css-extract-plugin
export var navbarTop = "menu-module--navbarTop--mhMjN";
export var navbarBottom = "menu-module--navbarBottom--mWtbU";
export var btn1 = "menu-module--btn1--oXUul";
export var btn2 = "menu-module--btn2--XyP-L";
export var btn3 = "menu-module--btn3--3SUjd";
export var btn4 = "menu-module--btn4--RxHw4";
export var text = "menu-module--text--XQvkN";